import { useEffect } from 'react';
import type { KeyPair } from '@/crypto/sodium';
import { propagateAssetWraps } from '@/features/notes/assetWraps';

/**
 * Completează atașamentele pentru share-urile adăugate după upload (inclusiv
 * cele făcute înainte să existe propagarea). Serverul întoarce listă goală
 * dacă nu e nimic de făcut sau dacă userul nu are drept de scriere.
 */
export function useAssetWrapPropagation({
  isEdit,
  noteId,
  hydrated,
  keyPair,
  tenantId,
}: {
  isEdit: boolean;
  noteId: string | null;
  hydrated: boolean;
  keyPair: KeyPair | null;
  tenantId: string;
}): void {
  useEffect(() => {
    if (!isEdit || !noteId || !hydrated || !keyPair) return;
    propagateAssetWraps({ noteId, tenantId, keyPair }).catch(() => {
      // Best-effort: se reîncearcă la următoarea deschidere.
    });
  }, [isEdit, noteId, hydrated, keyPair, tenantId]);
}
